import Constants from './constants';
export const handleErrorMessage = (error: any) => {
  return error.response?.data?.message || Constants.COMMON_SERVER_ERROR;
};

export const validateEmailField = (value: any) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (value) {
    if (!emailRegex.test(value)) return 'Invalid email address';
    else return null;
  } else {
    return null;
  }
};

export const validatePhoneField = (value: any) => {
  if (typeof value === 'string') {
    const sanitizedValue = value.replace(/[^\d]/g, ''); // Remove non-numeric characters
    const phoneRegex =
      /^(?:\+?61\s?)?(?:4\d{2}\s?\d{3}\s?\d{3}|0\d{1,2}\s?\d{4}\s?\d{4}|\(\d{1,2}\)\s?\d{4}\s?\d{4}|1300\s?\d{3}\s?\d{3}|1800\s?\d{3}\s?\d{3}|13\s?\d{4})$/;

    if (!phoneRegex.test(sanitizedValue)) {
      return 'Invalid Australian phone number';
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export const validateNameFields = (
  value: any,
  name: any,
  errorHandler: any,
  errorMessage: string
) => {
  if (!value.trim()) {
    errorHandler(name, errorMessage);
  } else {
    errorHandler(name, '');
  }
};

export const errorArrayHandler = (errors: any) =>
  Object.values(errors).filter((error) => error !== '');

export const invalidMandatoryFieldsHandler = (formFields: any) =>
  Object.values(formFields).filter(
    (entry: any) =>
      entry.required === true && (!entry.value || entry.value.length === 0)
  );
